import React, { useState, useEffect } from "react";
import DashboardLayout from "../DashboardLayout";
import ProvinceList from "./provinceList";
import {
  fetchCountriesList,
  fetchProvinceList,
} from "../../services/axios/apiManager";
import { useAppContext } from "../../services/context";
import { handleErrors } from "../../services/dataManager";
import { useSearchParams } from "react-router-dom";

const Provinces = ({ navigate }) => {
  const { state } = useAppContext();
  const { permissions } = state;
  const [searchParams] = useSearchParams();
  const [provinces, setProvinces] = useState([]);
  const [countries, setCountries] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Provinces");
    if (perms) {
      setGranted(perms);
    }
  };

  const getProvinces = async () => {
    const page = searchParams.get("page") || 1;
    const search = searchParams.get("search") || "";
    const status = searchParams.get("status");

    let filterString = "";
    if (search) filterString += `&search=${encodeURIComponent(search)}`;
    if (status && status !== "3") filterString += `&status=${status}`;

    const res = await fetchProvinceList(page, pagination.pageSize || 10, filterString);
    if (res?.data?.data) {
      setProvinces(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      await handleErrors(res, navigate, "Province list");
    }
  };

  const getCountries = async () => {
    const res = await fetchCountriesList(1, 1000);
    if (res?.data?.success && res?.data?.data) {
      setCountries(res.data.data);
    } else {
      await handleErrors(res, navigate, "Countries");
    }
  };

  useEffect(() => {
    extractPermissions();
    getCountries();
  }, []);

  useEffect(() => {
    getProvinces();
  }, [searchParams]);

  return (
    <DashboardLayout>
      <div>
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>System Settings</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#d1cdcdbf" }}
                  >
                    Provinces
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <ProvinceList
          provinces={provinces}
          setProvinces={setProvinces}
          pagination={pagination}
          setPagination={setPagination}
          countriesList={countries}
          granted={granted}
        />
      </div>
    </DashboardLayout>
  );
};

export default Provinces;
